export type TodoColorKey = 'yellow' | 'blue' | 'pink' | 'green' | 'purple' | 'orange';

export const TODO_COLORS: Record<TodoColorKey, { bg: string; ink: string; edge: string }> = {
  yellow: { bg: '#FFE16B', ink: '#6b5400', edge: '#f4c430' },
  blue:   { bg: '#93CEEF', ink: '#0c447c', edge: '#5bb0e4' },
  pink:   { bg: '#F8A7C7', ink: '#7a2247', edge: '#f07aa8' },
  green:  { bg: '#BFE39C', ink: '#2c5212', edge: '#9bd06e' },
  purple: { bg: '#CBB8F1', ink: '#3c2e70', edge: '#b095e8' },
  orange: { bg: '#FFC487', ink: '#7a4310', edge: '#fba94c' },
};

export const TODO_COLOR_ORDER: TodoColorKey[] = ['yellow', 'blue', 'pink', 'green', 'purple', 'orange'];

export const DEFAULT_CATEGORIES: { name: string; color: TodoColorKey }[] = [
  { name: 'Hoje',    color: 'yellow' },
  { name: 'Vendas',  color: 'blue'   },
  { name: 'Urgente', color: 'pink'   },
];
